// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__13pW6","rightAdornment":"Header_rightAdornment__3i8Ye"};